(() => {
  if(window.jfStorefrontReady)return;
  window.jfStorefrontReady=true;
  const searchForms=()=>document.querySelectorAll('[data-jf-search]');
  const syncSearch=()=>{
    const url=new URL(location.href),preview=url.searchParams.get('preview_theme_id');
    searchForms().forEach(form=>{
      if(preview){let input=form.querySelector('[name="preview_theme_id"]');if(!input){input=document.createElement('input');input.type='hidden';input.name='preview_theme_id';form.append(input);}input.value=preview;}
      const query=form.querySelector('[name="q"]');if(query)query.value=url.searchParams.get('q')||'';
    });
  };
  syncSearch();
  window.addEventListener('popstate',syncSearch);
  document.addEventListener('shopify:section:load',syncSearch);
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-jf-menu][open]').forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});
  });
  document.addEventListener('click',event=>document.querySelectorAll('[data-jf-menu][open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;}));
  document.addEventListener('cart:update',event=>{
    const count=event.detail?.data?.item_count;
    if(Number.isInteger(count)&&count>=0)document.querySelectorAll('[data-jf-cart-count]').forEach(el=>{el.textContent=String(count);});
  });
  let eventTimer;
  const syncSeasonalOffer=()=>{
    clearTimeout(eventTimer);
    const now=Date.now();
    let nextBoundary=Infinity;
    document.querySelectorAll('[data-jf-halloween]').forEach(element=>{
      const start=Date.parse(element.dataset.eventStart),end=Date.parse(element.dataset.eventEnd);
      if(!Number.isFinite(start)||!Number.isFinite(end)||now<start||now>=end){
        const fallback=element.querySelector('template[data-jf-halloween-fallback]');
        if(fallback)element.replaceWith(fallback.content.cloneNode(true));
        else element.hidden=true;
      }else{
        element.hidden=false;
        nextBoundary=Math.min(nextBoundary,end);
      }
    });
    if(Number.isFinite(nextBoundary))eventTimer=setTimeout(syncSeasonalOffer,Math.min(nextBoundary-now+50,2147483647));
  };
  syncSeasonalOffer();
  window.addEventListener('pageshow',syncSeasonalOffer);
  window.addEventListener('pagehide',()=>clearTimeout(eventTimer));
  document.addEventListener('shopify:section:load',syncSeasonalOffer);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)syncSeasonalOffer();});
})();
